import {
  TableBuildingListCell,
  TableEmptyCell,
  TableTextCell,
  TextListCell,
  toTableCellMultiValue,
  toTableCellTextFromName,
} from '../../Table'

import { CategoryTableCellName } from './CategoryTableRow.constants'

function toCategoryBuildingCellData(data) {
  return {
    ...toTableCellMultiValue(data.title),
    key: data.id,
  }
}

export function renderCategoryCell({ item, name, ...cellProps }) {
  const { [name]: value } = item

  switch (name) {
    case CategoryTableCellName.Name:
      return <TableTextCell {...cellProps} value={value} />

    case CategoryTableCellName.Buildings:
      return (
        <TableBuildingListCell
          {...cellProps}
          value={value?.map(toCategoryBuildingCellData)}
        />
      )

    case CategoryTableCellName.CategoryGroups:
      return (
        <TextListCell
          {...cellProps}
          value={value?.map(toTableCellTextFromName)}
        />
      )

    default:
      return <TableEmptyCell {...cellProps} />
  }
}
